import styled, { keyframes, css } from 'styled-components';

interface IContainerProps {
  isOpen: boolean;
  isFixed: boolean;
}

const fadeIn = keyframes`
  0% { transform: scale(.25); opacity: 0 }
 30% { transform: scale(.50); opacity: 0 }
 40% { transform: scale(.75); opacity: 1 }
 100% { transform: scale(1); opacity: 1 }

`;

const fadeOut = keyframes`
 0% { transform: scale(1); opacity: 1 }
 30% { transform: scale(.75); opacity: 1 }
 40% { transform: scale(.50); opacity: 1 }
 100% { transform: scale(0); opacity: 0 }
`;

export const Container = styled.div<IContainerProps>`
  left: 2px;
  bottom: 0;
  z-index: 1;

  width: 80px;
  height: 80px;
  
  flex-shrink: 0;
  cursor: pointer;   

  border-radius: 10px;

  align-items: center;
  background: #FFFFFF;

  justify-content: center;
  
  box-shadow: 10px 11px 21px 0px rgba(0, 0, 0, 0.16);
  display: ${({ isOpen }) => isOpen ? 'none' : 'flex'};

  ${({ isFixed }) => !isFixed ? css`
    position: relative;
  ` : css`
    position: sticky;
    top: 50%;
  `};
  
  animation: ${({ isOpen }) => isOpen ? fadeOut : fadeIn} .3s linear;

  &:hover {
    transform: scale(1.05);
  }

  @media(max-width: 420px) {
    width: 66px;
    height: 66px;
    
    bottom: -1px;
    margin: 0 0 0 0;
    border-radius: 8px;
  }

  @media(max-width: 820px) {
    width: 66px;
    height: 66px;
    
    bottom: -1px;
    margin: 0 0 0 0;
    border-radius: 8px;
  }
`;
